import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaFolder,
  FaFileAlt,
  FaSignOutAlt,
  FaUser,
} from "react-icons/fa";
import { FaBars } from "react-icons/fa";
import logo from "../../../assets/logo-IRC.png";
import { logout } from "../../../auth/Logout";
import "./Sidebar.css";

/**
 * Chercheur Sidebar shared component
 * Props:
 * - additionalItems?: React.ReactNode[]  // extra items inserted between projects and divider
 * - onHomeClick?: () => void             // callback when Home is clicked
 * - useLogoutHelper?: boolean            // whether to use shared logout helper (default true)
 */
const Sidebar = ({
  additionalItems = [],
  onHomeClick,
  useLogoutHelper = true,
}) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const handleLogout = () => {
    if (useLogoutHelper && typeof logout === "function") {
      logout(navigate);
    } else {
      // Fallback: clear storage and navigate
      try {
        document.cookie =
          "idchercheur=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        localStorage.clear();
        sessionStorage.clear();
      } catch {}
      navigate("/login", { replace: true });
    }
  };
  const toggleSidebar = () => setIsOpen((s) => !s);
  const closeSidebar = () => setIsOpen(false);

  return (
    <>
      {/* Mobile toggle */}
      <button
        className="sidebar-toggle"
        aria-label="Ouvrir le menu"
        onClick={toggleSidebar}
      >
        <FaBars />
      </button>
      {isOpen && <div className="sidebar-backdrop" onClick={closeSidebar} />}

      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="logo-container">
          <img src={logo} alt="IRC Logo" className="logo" />
        </div>

        <Link
          to="/home"
          style={{ textDecoration: "none" }}
          onClick={closeSidebar}
        >
          <div className="sidebar-item" onClick={onHomeClick}>
            <FaHome style={{ marginRight: "8px" }} />
            Accueil
          </div>
        </Link>

        <Link
          to="/chercheur-projet"
          style={{ textDecoration: "none" }}
          onClick={closeSidebar}
        >
          <div className="sidebar-item">
            <FaFolder style={{ marginRight: "8px" }} />
            Compétitions
          </div>
        </Link>

        <Link
          to="/MyProject"
          className="sidebar-item"
          style={{ textDecoration: "none" }}
          onClick={closeSidebar}
        >
          <FaFolder style={{ marginRight: "8px" }} />
          Mes Projets
        </Link>

        {/* Additional items slot */}
        {additionalItems}

        <Link
          to="/documents"
          className="sidebar-item"
          style={{ textDecoration: "none" }}
          onClick={closeSidebar}
        >
          <FaFileAlt style={{ marginRight: "8px" }} />
          Documents
        </Link>

        <Link
          to="/Mon-compte"
          className="sidebar-item"
          style={{ textDecoration: "none" }}
          onClick={closeSidebar}
        >
          <FaUser style={{ marginRight: "8px" }} />
          Mon Compte
        </Link>

        <div
          className="sidebar-item"
          style={{ cursor: "pointer" }}
          onClick={() => {
            handleLogout();
            closeSidebar();
          }}
        >
          <FaSignOutAlt style={{ marginRight: "8px" }} />
          Se déconnecter
        </div>
      </div>
    </>
  );
};

export default Sidebar;
